import { connect } from "react-redux";
import { push } from "react-router-redux";
import AssetPresentation from "./AssetPresentation.js";
import * as assetSelectedActions from "../../redux/actionCreators/assetSelectedActionCreators";
import { fetchAssetsTasks, postAssetsTask } from "../../redux/actionCreators/tasks/index.js";
import { fetchOperators } from "../../redux/actionCreators/operatorsListActionCreators.js";
import routes from "../../utils/routes";

const mapStateToProps = function (state, ownProps) {
  return {
    asset: state.assetSelected.assetSelected,
    assetView: state.assetSelected.assetView,
    assetId: ownProps.match.params.id,
    loggedUser: state.loggedUser,
    historicalMetrics: state.assetSelected.historicalMetrics,
    refillMetrics: state.assetSelected.refillMetrics,
    temperatureMetrics: state.assetSelected.temperatureMetrics,
    tiltMetrics: state.assetSelected.tiltMetrics,
    analyticsMetrics: state.assetSelected.analyticsMetrics,
    assetTasks: state.tasks.assetTasks,
    listOperators: state.operatorsList,
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    goToHome: () => dispatch(push(routes.routeHome())),
    goToAssets: () => dispatch(push(routes.routeAssets())),
    getAsset: (id) => dispatch(assetSelectedActions.fetchAsset(id)),
    getHistoricalMetrics: (id, idAsset, day) =>
      dispatch(assetSelectedActions.getHistoricalMetrics(id, idAsset, day)),
    getRefillMetrics: (id, idAsset, day) =>
      dispatch(assetSelectedActions.getRefillMetrics(id, idAsset, day)),
    clearRefill: () => dispatch(assetSelectedActions.clearRefill()),
    getTemperatureMetrics: (id, day) =>
      dispatch(assetSelectedActions.getTemperatureMetrics(id, day)),
    getTiltMetrics: (id, day) =>
      dispatch(assetSelectedActions.getTiltMetrics(id, day)),
    goToDevice: (id) => dispatch(push(routes.routeDevice(id))),
    getAnalytics: (id, serialNumber, day) =>
      dispatch(assetSelectedActions.getAnalytics(id, serialNumber, day)),
    setAssetView: (view) => dispatch(assetSelectedActions.setAssetView(view)),
    fetchAssetsTasks: (assetId) => dispatch(fetchAssetsTasks(assetId)),
    postAssetsTask: (data) => dispatch(postAssetsTask(data)),
    fetchOperators: (offset = 0, limit = 50) => dispatch(fetchOperators(offset, limit)),
  };
};

const AssetContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetPresentation);

export default AssetContainer;
